import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);

const state = {
    banners: [],
}

const actions = {
    getBanners({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('setLoadingStatus', true);
            axios.get('/api/banners')
                .then((response) => {
                    commit('setBanners', response.data.data);
                    commit('setLoadingStatus', false);
                    resolve(response.data.data);
                }).catch((e) => {
                console.log('unable to get Banners', e);
                commit('setLoadingStatus', false);
                reject(e);
            })
        })
    },
    addBanner({commit}, payload) {
        commit('setInfoMessage', 'A banner feltöltése és mentése folyamatban ...');
        return new Promise((resolve, reject) => {
            axios.post('/api/banners/add', payload).then((response) => {

                if(response.data && response.data.status == 'ok') {
                    commit('addBanner', response.data.data);
                    commit('setSuccessMessage', response.data.message);
                } else {
                    commit('setErrorMessage', response.data.message);
                }
                resolve(response.data.data);
            }).catch((e) => {
                reject(e);
            })
        });
    },
    updateBanner({commit}, payload) {
        commit('setInfoMessage', 'A banner mentése folyamatban ...');
        return new Promise((resolve, reject) => {
            axios.put('/api/banners/'+payload.id, payload).then((response) => {

                if(response.data && response.data.status == 'ok') {
                    commit('updateBanner', response.data.data);
                    commit('setSuccessMessage', response.data.message);
                } else {
                    commit('setErrorMessage', response.data.message);
                }
                resolve(response.data.data);
            }).catch((e) => {
                reject(e);
            })
        });
    },
    deleteBanner({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.delete('/api/banners/' + payload.id).then((response) => {
                if(response.data && response.data.status == 'ok') {
                    commit('setSuccessMessage', response.data.message);
                    commit('deleteBannerFromList', payload.id);
                } else {
                    commit('setErrorMessage', response.data.message);
                }
                resolve(response);
            }).catch((e) => {
                reject(e);
            })
        });
    },
}

const mutations = {
    setBanners(state, payload) {
        state.banners = payload;
    },
    addBanner(state, payload) {
        state.banners.push(payload);
    },
    updateBanner(state, payload) {
        let src = state.banners.find(s => s.id == payload.id);

        if(src) {
            state.banners.splice(state.banners.indexOf(src), 1, payload);
        }
    },
    deleteBannerFromList(state, id) {
        let obj = state.banners.find(s => s.id == id)

        if(obj) {
            state.banners.splice(state.banners.indexOf(obj), 1);
        }
    },
}

const getters = {
    bannerList: state => state.banners,
}

export const bannerStore = {
    state,
    actions,
    mutations,
    getters
}